import { baseUrl } from "util/APIBaseUrl";
import postRequest from "util/APIHelperPost";

/**
 * POST /v1/waitlist — public endpoint, no auth required.
 *
 * The backend answers 200 `{ success: true }` for a brand new address, for an
 * address already on the list and for anything the honeypot/time-trap silently
 * discards, so the client can treat every 200 as a success.
 */
// eslint-disable-next-line import/prefer-default-export
export const joinWaitlistApi = async (body) => {
  const requestPath = `${baseUrl}/v1/waitlist`;
  const response = await postRequest(requestPath, JSON.stringify(body), false);

  const status = response?.status;
  const payload = response?.payload;

  if (!response?.ok || payload?.error) {
    return { ...(payload || {}), status, ok: false };
  }

  return { ...payload, status, ok: true };
};
